<template>
  <nav class="navbar navbar-expand-lg navbar-light nav-sec fixed-top">
    <div class="container d-flex align-items-center">
      <router-link to="/" class="navbar-brand-link">
        <div class="navbar-brand">
          <img src="@/assets/images/logo.png" alt="DB Robot Logo">
        </div>
      </router-link>

      <button class="navbar-toggler" @click="toggleMenu" :class="{'collapsed': !isMenuOpen}" :aria-expanded="isMenuOpen">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="navbar-collapse" :class="{'collapse': true, 'show': isMenuOpen}" id="navbarSupportedContent">
        <!-- 모바일 메뉴 닫기 버튼 -->
        <button class="mobile-menu-close" @click="toggleMenu">
          <i class="fa fa-times"></i>
        </button>

        <!-- 모바일 첫번째 섹션: 로그인/회원가입 -->
        <div class="mobile-auth-section">
          <div v-if="!isLogin" class="auth-buttons">
            <button @click="loginModalOpen" class="btn btn-outline-primary">
              <i class="fa fa-sign-in me-1"></i>
              로그인
            </button>
            <router-link to="/signup">
              <button class="btn btn-primary">
                <i class="fa fa-user-plus me-1"></i>
                회원가입
              </button>
            </router-link>
          </div>

          <div v-else class="user-menu">
            <router-link to="/mypage" class="btn btn-outline-primary">
              <i class="fa fa-user me-1"></i>
              마이페이지
            </router-link>
            <button @click="logout" class="btn btn-light">
              <i class="fa fa-sign-out me-1"></i>
              로그아웃
            </button>
          </div>
        </div>

        <!-- 메뉴 네비게이션 -->
        <ul class="navbar-nav mx-auto">
          <li class="nav-item mobile-premium-item">
            <router-link to="/license" class="nav-link nav-link-premium">
              <i class="fa fa-crown me-1"></i>
              이용권 구매
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/database/openmarket" class="nav-link" :class="{'active' : $route.path =='/database/openmarket'}">
              오픈마켓 DB
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/database/business" class="nav-link" :class="{'active' : $route.path =='/database/business'}">
              사업자 DB
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/database/corp" class="nav-link" :class="{'active' : $route.path =='/database/corp'}">
              법인 DB
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/database/office" class="nav-link" :class="{'active' : $route.path =='/database/office'}">
              기업 DB
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/database/licensedb" class="nav-link" :class="{'active' : $route.path =='/database/licensedb'}">
              인허가 DB
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/category-search" class="nav-link" :class="{'active' : $route.path =='/category-search'}">
              업종별 검색
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/faq" class="nav-link" :class="{'active' : $route.path =='/faq'}">
              FAQ
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/notice" class="nav-link" :class="{'active' : $route.path =='/notice'}">
              공지사항
            </router-link>
          </li>
        </ul>

        <div class="right-nav-sec">
          <div v-if="!isLogin" class="auth-buttons">
            <button @click="loginModalOpen" class="btn btn-outline-primary">
              <i class="fa fa-sign-in me-1"></i>
              로그인
            </button>
            <router-link to="/signup">
              <button class="btn btn-primary">
                <i class="fa fa-user-plus me-1"></i>
                회원가입
              </button>
            </router-link>
          </div>

          <div v-else class="user-menu">
            <router-link to="/mypage" class="btn btn-outline-primary">
              <i class="fa fa-user me-1"></i>
              마이페이지
            </router-link>
            <button @click="logout" class="btn btn-light">
              <i class="fa fa-sign-out me-1"></i>
              로그아웃
            </button>
          </div>

          <router-link to="/license" class="ms-2">
            <button class="btn btn-premium">
              <i class="fa fa-crown me-1"></i>
              이용권 구매
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <loginModal :loginInit="loginInit" ref="loginModal"/>
  </nav>
</template>

<script>
import loginModal from './Modals/LoginModal'

export default {
  name: "Header",
  components:{
    loginModal
  },
  data(){
    return {
      isLogin: false,
      loginModel : null,
      isMenuOpen: false
    }
  },
  async created() {
    await this.loginInit()
  },
  watch: {
    async user(data){
      if(data == false){
        this.isLogin = false
      }
    }
  },
  methods:{
    logout(){
      this.authStore.logout()
      this.isLogin = false
      // 현재 페이지 새로고침
      this.$router.go(0)
    },
    async loginInit(){
      var setupUserModel = await this.authStore.setupUser()
      if(setupUserModel != undefined && setupUserModel != null) {
        this.isLogin = true
        this.loginModel = setupUserModel
      }
    },
    loginModalOpen(){
      this.$refs.loginModal.open()
    },
    toggleMenu(){
      this.isMenuOpen = !this.isMenuOpen
    }
  }
}
</script>

<style scoped>
/* 네비게이션 바 스타일 */
.nav-sec {
  background: #ffffff;
  padding: 0.6rem 0;
  transition: all 0.3s;
  border: none !important;
  border-top: none !important;
  border-bottom: none !important;
}

.navbar {
  border: none !important;
  border-top: none !important;
  border-bottom: none !important;
}

.navbar-collapse {
  flex-grow: 1;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand-link {
  text-decoration: none;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  margin: 0;
  flex-shrink: 0;
  z-index: 10001;
  position: relative;
}

.navbar-brand img {
  width: 40px;
  height: 40px;
  transition: transform 0.3s;
}

.navbar-brand:hover img {
  transform: rotate(-10deg) scale(1.1);
}

.brand-text {
  display: flex;
  align-items: baseline;
  font-size: 22px;
  font-weight: 700;
}

.brand-db {
  color: #1e90ff;
  font-weight: 800;
}

.brand-robot {
  color: #333;
  font-weight: 800;
}

/* 네비게이션 링크 */
.navbar-nav {
  gap: 0;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.nav-link {
  color: #333 !important;
  font-size: 12px;
  font-weight: 600;
  padding: 0.5rem 0.5rem !important;
  border-radius: 8px;
  transition: all 0.3s;
  border: 2px solid transparent;
  display: flex;
  align-items: center;
  text-decoration: none;
  letter-spacing: -0.3px;
  position: relative;
  white-space: nowrap;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  background: #1e90ff;
  transition: width 0.3s;
}

.nav-link:hover {
  color: #1e90ff !important;
  background: #f0f8ff;
}

.nav-link:hover::after {
  width: 60%;
}

.nav-link.active {
  color: #1e90ff !important;
  background: #e7f3ff;
  border-color: #1e90ff;
  font-weight: 800;
}

.nav-link.active::after {
  width: 80%;
}

.nav-link i {
  font-size: 16px;
  margin-right: 2px;
}

/* 우측 네비게이션 */
.right-nav-sec {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.auth-buttons, .user-menu {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* 버튼 스타일 */
.btn {
  padding: 0.4rem 0.8rem;
  font-size: 12px;
  font-weight: 700;
  border-radius: 8px;
  transition: all 0.3s;
  border: none;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  letter-spacing: -0.3px;
  white-space: nowrap;
}

.btn i {
  font-size: 14px;
}

.btn-primary {
  background: white;
  color: black;
  border: 1px solid black;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  background: #f0f0f0;
  color: black;
  border: 1px solid black;
}

.btn-outline-primary {
  background: white;
  color: black;
  border: 1px solid black;
}

.btn-outline-primary:hover {
  background: #f0f0f0;
  color: black;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  border: 1px solid black;
}

.btn-light {
  background: #f8f9fa;
  color: #666;
  border: 1px solid #e9ecef;
}

.btn-light:hover {
  background: #e9ecef;
  transform: translateY(-2px);
}

.btn-premium {
  background: white;
  color: black;
  font-weight: 600;
  border: 1px solid black;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.btn-premium:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  background: #f0f0f0;
  color: black;
  border: 1px solid black;
}

.btn-premium i {
  color: black;
  opacity: 0.9;
}

/* 모바일 토글 버튼 */
.navbar-toggler {
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
}

.navbar-toggler:focus {
  box-shadow: none;
  outline: none;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%231e90ff' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

/* 모바일 첫번째 섹션 - PC에서는 숨김 */
.mobile-auth-section {
  display: none;
}

/* 모바일 이용권 구매 메뉴 - PC에서는 숨김 */
.mobile-premium-item {
  display: none;
}

/* 모바일 메뉴 닫기 버튼 - PC에서는 숨김 */
.mobile-menu-close {
  display: none;
}

/* 반응형 디자인 */
@media (max-width: 991px) {
  .navbar-collapse {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 75%;
    max-width: 320px;
    background: white;
    padding: 0;
    margin: 0;
    border-radius: 0;
    box-shadow: -4px 0 20px rgba(0,0,0,0.15);
    border: none;
    overflow-y: auto;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    z-index: 9999;
  }

  .navbar-collapse.show {
    transform: translateX(0);
  }

  .navbar-collapse.collapse:not(.show) {
    display: flex !important;
  }

  /* 모바일 메뉴 닫기 버튼 */
  .mobile-menu-close {
    display: flex;
    position: absolute;
    top: 16px;
    right: 16px;
    width: 36px;
    height: 36px;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    z-index: 10;
  }

  .mobile-menu-close:hover {
    background: #e9ecef;
    border-color: #adb5bd;
  }

  .mobile-menu-close i {
    font-size: 18px;
    color: #495057;
  }

  /* 모바일 첫번째 섹션: 로그인/회원가입 */
  .mobile-auth-section {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 10px;
    margin: 0;
    margin-bottom: 0;
    padding: 70px 16px 8px 16px;
    border-bottom: none;
    order: -1;
    width: 100%;
    box-sizing: border-box;
  }

  .mobile-auth-section .auth-buttons,
  .mobile-auth-section .user-menu {
    flex-direction: row;
    width: 100%;
    gap: 10px;
    display: flex;
    flex: 1;
  }

  .mobile-auth-section .auth-buttons .btn,
  .mobile-auth-section .user-menu .btn,
  .mobile-auth-section .auth-buttons a,
  .mobile-auth-section .user-menu a {
    flex: 1;
    min-width: 0;
  }

  .mobile-auth-section .auth-buttons a .btn,
  .mobile-auth-section .user-menu a .btn {
    width: 100%;
  }

  /* PC용 right-nav-sec는 모바일에서 숨김 */
  .right-nav-sec {
    display: none !important;
  }

  /* 모바일 이용권 구매 메뉴 표시 */
  .mobile-premium-item {
    display: block;
    margin: 0;
    padding: 0;
  }

  .mobile-premium-item:first-child {
    margin-top: 0;
  }

  .nav-link-premium {
    background: linear-gradient(135deg, #fff9e6 0%, #fff4d6 100%);
    color: #ff8c00 !important;
    font-weight: 700;
    border-left: 3px solid #ffd700;
    padding-left: 13px !important;
    border-top: none;
    padding-top: 14px !important;
  }

  .nav-link-premium:hover {
    background: linear-gradient(135deg, #fff4d6 0%, #ffedd6 100%);
    color: #ff7700 !important;
  }

  .nav-link-premium i {
    color: #ffd700;
  }

  .btn {
    width: auto;
    justify-content: center;
    padding: 12px 8px;
    font-size: 12px;
    border-radius: 10px;
    background: #f8f9fa;
    color: #495057;
    border: 1px solid #dee2e6;
    font-weight: 600;
    transition: all 0.2s;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  }

  .btn:hover {
    background: #e9ecef;
    border-color: #adb5bd;
    color: #212529;
    transform: translateY(-1px);
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }

  .btn i {
    font-size: 12px;
  }

  .btn-primary {
    background: #1e90ff;
    color: white;
    border: 1px solid #1e90ff;
  }

  .btn-primary:hover {
    background: #0078d4;
    border-color: #0078d4;
    color: white;
  }

  .btn-outline-primary {
    background: white;
    color: #1e90ff;
    border: 1px solid #1e90ff;
  }

  .btn-outline-primary:hover {
    background: #1e90ff;
    border-color: #1e90ff;
    color: white;
  }

  .btn-light {
    background: white;
    color: #6c757d;
    border: 1px solid #dee2e6;
  }

  .btn-light:hover {
    background: #f8f9fa;
    border-color: #adb5bd;
    color: #495057;
  }

  .btn-premium {
    background: linear-gradient(135deg, #ffd700 0%, #ffb700 100%);
    color: #333;
    border: 1px solid #ffb700;
    font-weight: 700;
  }

  .btn-premium:hover {
    background: linear-gradient(135deg, #ffed4e 0%, #ffd700 100%);
    border-color: #ffd700;
    color: #333;
  }

  .btn-premium i {
    color: #333;
  }

  .ms-2 {
    margin-left: 0 !important;
  }

  /* 메뉴 네비게이션 */
  .navbar-nav {
    order: 1;
    margin: 0 !important;
    gap: 0;
    flex-direction: column;
    padding: 0;
    padding-inline-start: 0 !important;
    width: 100%;
  }

  .navbar-nav.mx-auto {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .nav-item {
    width: 100%;
  }

  .nav-link {
    padding: 14px 16px !important;
    margin: 0;
    width: 100%;
    display: block;
    justify-content: flex-start;
    background: white;
    border-radius: 0;
    font-size: 14px;
    border: none;
    border-bottom: 1px solid #f0f0f0;
  }

  .nav-item:last-child .nav-link {
    border-bottom: none;
  }

  .nav-link::after {
    display: none;
  }

  .nav-link:hover {
    background: #f8f9fa;
    color: #1e90ff !important;
  }

  .nav-link.active {
    background: #e7f3ff;
    color: #1e90ff !important;
    font-weight: 700;
    border-left: 3px solid #1e90ff;
    padding-left: 13px !important;
  }
}

@media (max-width: 576px) {
  .brand-text {
    font-size: 20px;
  }

  .navbar-brand img {
    width: 32px;
    height: 32px;
  }
}

/* 드롭다운 스타일 */
.dropdown-toggle::after {
  margin-left: 0.3rem;
}

.dropdown-menu {
  margin-top: 0.5rem;
  border: 1px solid #e5e8eb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  min-width: 180px;
}

.dropdown-item {
  padding: 0.6rem 1.2rem;
  font-size: 14px;
  font-weight: 600;
  color: #333d4b;
  transition: all 0.2s;
}

.dropdown-item:hover {
  background: #f0f8ff;
  color: #1e90ff;
  padding-left: 1.4rem;
}

.dropdown-item:active,
.dropdown-item.active {
  background: #1e90ff;
  color: #fff;
}

.dropdown-divider {
  margin: 0.5rem 0;
  border-color: #e5e8eb;
}

/* 헬퍼 클래스 */
.me-1 {
  margin-right: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>